export var activeOptions = [
    {
        id: 200,
        value: true,
        inactive: "Active?",
        active: "Active"
    },
    {
        id: 201,
        value: false,
        inactive: "InActive?",
        active: "InActive"
    }
];
